<template>
  <v-slide-x-transition class="row justify-end" group leave-absolute hide-on-leave>
    <template v-if="isEditing">
      <v-col cols="auto" key="action-cancel">
        <v-btn color="grey" rounded outlined @click="$emit('cancel')" :small="$vuetify.breakpoint.lgAndDown">
          <v-icon left>close</v-icon>
          {{$t('Global.Action.cancel')}}
        </v-btn>
      </v-col>
      <v-col cols="auto" key="action-save">
        <v-btn color="success" rounded outlined @click="$emit('save')" :small="$vuetify.breakpoint.lgAndDown">
          <v-icon left>save</v-icon>
          {{$t('Global.Action.save')}}
        </v-btn>
      </v-col>
    </template>
    <template v-else>
      <v-col v-if="canPublish && isPublished" cols="auto" key="action-unpublish">
        <v-btn color="grey" rounded outlined @click="$emit('unpublish')" :small="$vuetify.breakpoint.lgAndDown">
          <v-icon left>public_off</v-icon>
          {{$t('Global.Action.unpublish')}}
        </v-btn>
      </v-col>
      <v-col v-if="canPublish && !isPublished" cols="auto" key="action-publish">
        <v-btn color="secondary" rounded outlined @click="$emit('publish')" :small="$vuetify.breakpoint.lgAndDown">
          <v-icon left>public</v-icon>
          {{$t('Global.Action.publish')}}
        </v-btn>
      </v-col>
      <v-col v-if="canEdit" cols="auto" key="action-edit">
        <v-btn color="secondary" rounded outlined @click="$emit('edit')" :small="$vuetify.breakpoint.lgAndDown">
          <v-icon left>edit</v-icon>
          {{$t('Global.Action.edit')}}
        </v-btn>
      </v-col>
    </template>
  </v-slide-x-transition>
</template>

<script>
export default {
  name: 'PageActions',
  props: {
    isEditing: { type: Boolean, required: true },
    isManaged: { type: Boolean, required: true },
    isPublished: { type: Boolean, required: true }
  },
  computed: {
    canEdit() {
      return this.$store.getters['auth/isAdmin'] || !this.isManaged
    },
    canPublish() {
      return this.$store.getters['auth/isAdmin'] && this.isManaged
    }
  }
}
</script>